const fruitPulpData = {
  hero_section: {
    title: "Fruit Pulp Collection",
    description: "100% Natural • No Preservatives • Rich in Flavor",
    src: "videos/fruit.webm",
  },
  description: {
    title: "Premium Fruit Pulp Collection",
    main_description:
      "Discover our range of 100% natural fruit pulps, crafted to preserve the authentic flavors and freshness of the finest fruits.",
    segment_description:
      "Effortless juice preparation with our ready-to-use fruit pulps.",
    variety_description:
      "Available in a variety of flavors and pack sizes to suit every need.",
  },
  products: [
    {
      id: "mango",
      name: "Mango Fruit Pulp",
      image: "fp_mango_sc.webp",
      features: [
        "Handpicked Alphonso & Totapuri",
        "Rich, aromatic, and sweet",
        "Perfect for juices, desserts, and smoothies",
        "Consistent quality for HORECA & home",
      ],
      meta: {
        weight: "1kg Pack",
      },
    },
    {
      id: "pineapple",
      name: "Pineapple Fruit Pulp",
      image: "fs_pineapple_sc.webp",
      features: [
        "Sun-ripened pineapples",
        "Sweet-tart balance",
        "Versatile for sweet & savory",
        "Rich in vitamin C",
      ],
      meta: {
        weight: "1kg Pack",
      },
    },
    {
      id: "guava",
      name: "Guava Fruit Pulp",
      image: "fs_guava_sc.webp",
      features: [
        "Pink guava, fragrant & bold",
        "Rich in vitamin C",
        "Smooth, vibrant, ready-to-use",
        "Great for drinks, ice creams, jams",
      ],
      meta: {
        weight: "1kg Pack",
      },
    },
    {
      id: "jackfruit",
      name: "Jackfruit Pulp",
      image: "fs_jackfruit_sc.webp",
      features: [
        "Sweet, honey-like flavor",
        "Meaty, fibrous texture",
        "Minimal processing",
        "Ready-to-use for sweets & desserts",
      ],
      meta: {
        weight: "1kg Pack",
      },
    },
    {
      id: "avocado",
      name: "Avocado Pulp",
      image: "fp_avocado_sc.webp",
      features: [
        "Premium Hass avocados",
        "Creamy, rich, nutrient-dense",
        "No peeling or mashing needed",
        "Perfect for dips, spreads, smoothies",
      ],
      meta: {
        weight: "1kg Pack",
      },
    },
    {
      id: "coconut",
      name: "Tender Coconut Pulp",
      image: "fs_coconut_sc.webp",
      features: [
        "Soft, jelly-like texture",
        "Naturally hydrating",
        "Perfect for drinks & desserts",
        "Nutrient-rich & versatile",
      ],
      meta: {
        weight: "1kg Pack",
      },
    },
    {
      id: "chikoo",
      name: "Chikoo (Sapota) Pulp",
      image: "fs_chikoo_sc.webp",
      features: [
        "Handpicked, ripened sapotas",
        "Caramel-like flavor",
        "Creamy, smooth texture",
        "Ready-to-use, no prep needed",
      ],
      meta: {
        weight: "1kg Pack",
      },
    },
    {
      id: "passion",
      name: "Passion Fruit Pulp",
      image: "fs_passion_sc.webp",
      features: [
        "Tart, tropical, tangy",
        "Carefully selected fruits",
        "Perfect for drinks & desserts",
        "Rich in antioxidants",
      ],
      meta: {
        weight: "1kg Pack",
      },
    },
    {
      id: "dates",
      name: "Coconut & Dates Pulp",
      image: "fs_cocodate_sc.webp",
      features: [
        "Tender coconut & rich dates",
        "Naturally sweet, no added sugar",
        "Smooth, nourishing blend",
        "Great for health bowls & desserts",
      ],
      meta: {
        weight: "1kg Pack",
      },
    },
  ],

  features: [
    {
      id: 1,
      title: "100% Natural Ingredients",
      description: "Made from fresh, high-quality fruits without additives.",
    },
    {
      id: 2,
      title: "Convenient and Ready to Use",
      description: "Save prep time with pulps that are ready out of the pack.",
    },
    {
      id: 3,
      title: "Rich in Flavor and Nutrition",
      description: "Vitamins, antioxidants, and authentic fruit taste.",
    },
    {
      id: 4,
      title: "Versatile Applications",
      description: "Great for smoothies, desserts, beverages, and more.",
    },
  ],
  text_section: {
    title: "Fruit Pulps",
    description:
      "Our fruit pulps are nature's sweetness captured at peak ripeness-pure, vibrant and ready to use. Each batch is made from handpicked fruits and minimally processed to preserve natural color, taste and nutrition. Whether you are crafting beverages, desserts or sauces, our pulp offers consistent texture and authentic tropical flavor.",
  },
  feature_text_section: {
    title: "Effortless Juice Prep",
    subline: "Just scoop, serve, and sip - fresh flavor in seconds!",
    description:
      "For the Hotel, Restaurant, and Cafes, it means faster prep, reduced wastage, and reliable quality for large scale operations. For home users, it's the easiest way to bring premium fruit flavor into everyday recipes- just scoop, blend or cook.",
  },
  feature_cards_info_card: [
    {
      id: 1,
      image: "fp_HORECA-3.webp",
      title: "Faster Prep Time",
      description:
        "Ready-to-use pulps eliminate time-consuming fruit processing, allowing your kitchen to operate more efficiently.",
    },
    {
      id: 2,
      image: "fp_HORECA-1.webp",
      title: "Reduced Wastage",
      description:
        "Precise portions and longer shelf life mean minimal waste, helping you maintain better inventory control and cost efficiency.",
    },
    {
      id: 3,
      image: "fp_HORECA-2.webp",
      title: "High-Volume Kitchen",
      description:
        "Perfect for smoothies, garnishes, sauces, and desserts while minimizing waste and prep time.",
    },
  ],
  overlay_card: [
    {
      id: 1,
      key: "natural-source",
      image: "fp_Naturally_sourced.webp",
      title: "Naturally sourced",
      description:
        "Made from ripe, carefully selected fruits for maximum freshness",
    },
    {
      id: 2,
      key: "kitchen-ready",
      image: "fp_Kitchen_ready.webp",
      title: "Kitchen-ready convenience",
      description:
        "No peeling, chopping, or blending—just open and use instantly.",
    },
    {
      id: 3,
      key: "consistent-texture",
      image: "fp_Consistent_texture.webp",
      title: "Consistent texture and taste",
      description:
        "Perfectly smooth, thick, and full of fruit flavor in every batch",
    },
    {
      id: 4,
      key: "multi-purpose",
      image: "fp_Multi_purpose.webp",
      title: "Multi-purpose use",
      description:
        "Ideal for juices, desserts, smoothies, ice creams, and savory applications.",
    },
  ],
  why_choose_section: {
    title: "Why Choose Our Fruit Pulp",
    description: "Discover the perfect blend of convenience, quality, and authentic flavors that make our fruit pulps stand out.",
  },
};

export default fruitPulpData;
